import { render, staticRenderFns } from "./mind-problem-statement-section.vue?vue&type=template&id=66f5824e&"
import script from "./mind-problem-statement-section.vue?vue&type=script&lang=js&"
export * from "./mind-problem-statement-section.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports